import { Component, OnInit, inject } from '@angular/core';
import { BasicTableComponent } from '../../basic-table/basic-table.component';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { BasicTablePipe } from '../../basic-table/basic-table.pipe';
import { DataNotFoundComponent } from '../../../../../shared/components/data-not-found/data-not-found.component';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InstructionsDocumentDto, RideDocumentDto } from '../../../../../shared/interfaces/ride-firestore';
import { RideCargoExtraFields } from '../../../../../shared/enums/extraFields';
import { MapRideServiceService } from '../../../services/map-ride-service.service';
import { StateService } from '../../../../../shared/services/state.service';
import { Equipments } from '../../../../../shared/enums/equipments';

@Component({
  selector: 'app-passegers-equipments-dialog',
  standalone: true,
  imports: [BasicTableComponent, ButtonComponent, BasicTablePipe, DataNotFoundComponent],
  templateUrl: './passegers-equipments-dialog.component.html',
  styleUrl: './passegers-equipments-dialog.component.scss',
})
export class PassegersEquipmentsDialogComponent implements OnInit {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  private readonly mapRideService = inject(MapRideServiceService);
  private readonly stateService = inject(StateService);

  passengers: any = [];

  ngOnInit() {
    console.log(this.config.data);
    this.setPassengers(this.config.data.docRide);
  }

  setPassengers(ride: RideDocumentDto) {
    this.passengers = ride.ride_cargoes
      ?.filter(rideCargo => rideCargo.student_id != 0)
      .map(rideCargo => {
        const firstName = rideCargo.ride_cargo_extra_fields?.find(field => field.key_id == RideCargoExtraFields.FirstName)?.value;
        const lastName = rideCargo.ride_cargo_extra_fields?.find(field => field.key_id == RideCargoExtraFields.LastName)?.value;
        const fullName = `${firstName} ${lastName}`;

        const filteredEquipment = ride.ride_passenger_equipments?.filter(pe => pe.passenger_id == rideCargo.student_id) ?? [];
        const mappedEquipments = filteredEquipment.map(e => {
          const equipmentId = Equipments[e.equipment_name?.replaceAll(' ', '') as keyof typeof Equipments];
          const base64Img = this.stateService.getEquipmentsFiles().find((e: any) => e.equipmenId == equipmentId)?.base64File;
          return {
            name: e.equipment_name,
            icon: base64Img ? `data:image/jpeg;base64, ${base64Img}` : '',
          };
        });

        let cargoContacts = JSON.parse(rideCargo.ride_cargo_extra_fields?.find(field => field.key_id == RideCargoExtraFields.StudentContacts)?.value ?? '[]') ?? [];
        let cargoInstructions: { type: string; description: string }[] = [];
        const addCargoInstruction = (inst: InstructionsDocumentDto) => {
          // If there is no instruction of this type
          if (!cargoInstructions.some(i => i.type == inst.type)) {
            cargoInstructions.push({ type: inst.type ?? '', description: inst.description ?? '' });
          }
        };

        ride.ride_stops?.forEach(stop => {
          const currentRideStopCargo = stop.ride_stop_cargoes?.find(x => x.ride_cargo_id == rideCargo.original_ride_cargo_id);
          if (currentRideStopCargo) {
            currentRideStopCargo.instructions?.forEach(inst => {
              addCargoInstruction(inst);
            });
          }
        });

        const mapContacts = () => {
          if (!Array.isArray(cargoContacts)) {
            cargoContacts = [];
          }
          console.log(cargoContacts);

          return cargoContacts?.map((contact: { FullName: string; RelationType: string; Mobile: string; IsPrimaryContact?: boolean }) => {
            return {
              name: contact.FullName,
              relation: contact.RelationType,
              number: this.mapRideService.formatPhoneNumber(contact.Mobile ?? ''),
              isPrimary: contact.IsPrimaryContact,
            };
          });
        };

        console.log(cargoContacts);

        return {
          name: fullName,
          contacts: mapContacts(),
          equipment: mappedEquipments.length > 0 ? mappedEquipments : [{ name: 'None Required', icon: '' }],
          studentInstructions: cargoInstructions,
        };
      });
  }
}
